import CardHeader, {type CardHeaderProps} from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import {type Theme} from '@mui/material/styles';
import {mergeSlotProps} from '@mui/material/utils';
import {FC, ReactNode} from 'react';

type CardHeaderSlotProps = NonNullable<CardHeaderProps['slotProps']>;

export type PanelHeaderProps = {
  title?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  rootProps?: CardHeaderProps;
  titleProps?: CardHeaderSlotProps['title'];
  iconProps?: CardHeaderSlotProps['avatar'];
  actionProps?: CardHeaderSlotProps['action'];
  contentProps?: CardHeaderSlotProps['content'];
};

const PanelHeader: FC<PanelHeaderProps> = ({
  title,
  icon,
  action,
  rootProps = {},
  titleProps = {},
  iconProps = {},
  actionProps = {},
  contentProps = {},
}) => {
  return (
    <>
      <CardHeader
        avatar={icon}
        title={title}
        action={action}
        slotProps={{
          content: mergeSlotProps<NonNullable<CardHeaderSlotProps['content']>>(
            {},
            contentProps,
          ),
          title: mergeSlotProps<NonNullable<CardHeaderSlotProps['title']>>(
            {
              component: 'h2',
              variant: 'h6',
            },
            titleProps,
          ),
          action: mergeSlotProps<NonNullable<CardHeaderSlotProps['action']>>(
            {
              sx: {
                marginBlockStart: 0,
              },
            },
            actionProps,
          ),
          avatar: mergeSlotProps<NonNullable<CardHeaderSlotProps['avatar']>>(
            {
              sx: {
                marginInlineEnd: 1,
              },
            },
            iconProps,
          ),
          root: mergeSlotProps<Omit<CardHeaderProps, 'title'>>(
            {
              sx: (theme: Theme) => ({
                backgroundColor: 'background.paper',
                backgroundImage: theme.vars?.overlays?.[1] || 'none',
                marginBlock: 0,
                paddingInline: 2,
                paddingBlock: 1,
                ...theme.applyStyles('light', {
                  backgroundColor: 'grey.100',
                  backgroundImage: 'none',
                }),
              }),
            },
            rootProps,
          ),
        }}
      />

      <Divider />
    </>
  );
};

export default PanelHeader;
